import { useCallback } from 'react';
import { assignmentErrorsStateJ } from '../AllCompaniesStateJ';
import { useAtom } from 'jotai';

export function useTemplateAssignmentErrors() {
  const [errors, setErrors] = useAtom(assignmentErrorsStateJ);

  const onClose = useCallback(() => {
    setErrors(null);
  }, [setErrors]);

  return { errors, onClose };
}
